import { Component, Input, OnInit } from '@angular/core';
import {ListingCategory} from "../../classes/enums";
import {HasSubscriptions} from "../has-subscriptions";
import {CommunicationService} from "../../services/communication.service";

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent extends HasSubscriptions implements OnInit {
  @Input() listingCategory?: ListingCategory;

  ListingCategory = ListingCategory;

  constructor(private communicationService: CommunicationService) {
    super();
  }

  ngOnInit() {
    this.addSub(this.communicationService.listings.currentShownListingType.subscribe((s) => {
      this.listingCategory = s;
    }));
  }
}
